import APIUtil from "./APIUtil";

class CommonAPI {
  exportToPDF(payload) {
    return APIUtil.callPostAPI("api/Report/ExportDataToPDF", payload);
  }
}

export default new CommonAPI();
